//tabs driven by core js.
/* global mzFunc mzTabs */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';

import WheelCard from '../../2_Molecules/WheelCard/WheelCard'

export const WheelsList = ({ Wheels, DisabledIndexes, SelectedIndex, HandleSelectedWheel, defaultWheelSize, showFinancePrice,...props }) => {
    const hasDefaultWheelSize = (formatedData, defaultSize) => {
        const hasKey = Number(defaultSize) in formatedData;
        return hasKey;
    }   

	const { t, i18n } = useTranslation(['wheels']);
    const [wheelsData, setWheelsData] = React.useState(parceWheelsData());
    const [sizes] = React.useState(Object.keys(wheelsData));

	const gtmHelper = new GTMHelper();

    const initWheelTab = sessionStorage.getItem(Constants.SelectedWheelSize) ? sessionStorage.getItem(Constants.SelectedWheelSize) : defaultWheelSize ? String(defaultWheelSize) : sizes[0];

    const [selectedWheelsSize, setSelectedWheelsSize] = React.useState(initWheelTab);
    const [warningMessage, setWarningMessage] = React.useState(getWarningMessage(initWheelTab));
    const summaryCalculator = window.summaryCalculator;
    function handleSelectedWheel(index) {
        HandleSelectedWheel(index);
    }

    function getWarningMessage(newSize) {
        let newMessage = null;

        if (!defaultWheelSize) return newMessage;

        if (Number(newSize) > Number(defaultWheelSize)) {
            i18n.language == "en" ? newMessage = `${newSize}″ ${t('wheel_def_pre')} ${t('wheel_def_large')} ${t('wheel_def_suff')}` : newMessage = `${t('wheel_def_pre')} ${newSize}″ ${t('wheel_def_large')} ${t('wheel_def_suff')}`
        } else if (Number(newSize) < Number(defaultWheelSize)) {
            i18n.language == "en" ? newMessage = `${newSize}″ ${t('wheel_def_pre')} ${t('wheel_def_small')} ${t('wheel_def_suff')}` : newMessage = `${t('wheel_def_pre')} ${newSize}″ ${t('wheel_def_small')} ${t('wheel_def_suff')}`
        }

        return newMessage;
    }


    function groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    function parceWheelsData() {
        var data = [];
        let formatedData = {};

        for (const index in Wheels) {
            data.push(Wheels[index]);
        }
        
        data.forEach((wheel, index) => {
            wheel.selected = SelectedIndex!==null?Number(SelectedIndex) === index:null;
            wheel.disabled = DisabledIndexes.includes(index);
            wheel.index = index;
        })

        if (data.length) {
            formatedData = groupBy(data, 'size');
        }

        const HASDEFAULTWHEELSIZE = hasDefaultWheelSize(formatedData, defaultWheelSize);
        // Add default wheel size array
        if(defaultWheelSize !== 0 && !HASDEFAULTWHEELSIZE)    
            formatedData[defaultWheelSize] = [];

        return (formatedData);
    }

    const getWheelSizeSuffix = (size) => {
        if (!size) return '';
        let suffix = '"';

        if (defaultWheelSize && Number(size) === Number(defaultWheelSize)) {
            suffix += t('wheel_size');
        }

        return suffix
    }

    React.useEffect(() => {
        setWheelsData(parceWheelsData());

		if(typeof mzFunc === 'object' && typeof mzTabs === 'object'){
			mzFunc.waitForEl('.mzBuildandPrice .mz-tabs').then(function(components){mzTabs.init(components);});
		}

    }, [Wheels]);

    return (
        <div className="wheels-list">
			<div className="mz-tabs">
				<div className="mz-tabs-menu">
					<div className="mz-tabs-menu-container">
					   <div className="mz-tabs-menu-inner">
                        {
			                sizes.map((size, key) => (
			                    <a
			                        className={size === selectedWheelsSize ? 'wheels-list__tab active' : 'wheels-list__tab'}
			                        onClick={() => {
			                            setSelectedWheelsSize(sizes[key]);

			                            sessionStorage.setItem(Constants.SelectedWheelSize, sizes[key]);

                                        setWarningMessage(getWarningMessage(size));

										gtmHelper.setGTM({'action':'Tab Click', 'wheel tab': sizes[key]}, true, false);
			                        }}
			                        key={key}
			                    >
			                        {size}{getWheelSizeSuffix(size)}
			                    </a>
			                ))

                        }
						</div>
					</div>
					<div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel mz-svg--rotate180"></i></div>
					<div className="mz-tabs-menu--right active"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel"></i></div>
				</div>
            </div>
            {wheelsData[selectedWheelsSize] && wheelsData[selectedWheelsSize].length > 0 ?
            <div className='wheels-list__tab-content'>
                <p className="wheels-list__warning-message paragraph paragraph--tight">
                    {ReactHtmlParser(t("wheels_disclaimer"))}
                </p>
                {
                    warningMessage && (
                        <p className="wheels-list__warning-message paragraph paragraph--tight"><i className="mz-svg mz-svg-warning mz-svg--red"></i>&nbsp;{warningMessage}</p>
                    )
                }
                {wheelsData[selectedWheelsSize].map((wheel, key) =>
                    <WheelCard Wheel={wheel} Disabled={wheel.disabled} Selected={wheel.selected} Index={key} HandleSelectedWheel={handleSelectedWheel} key={key} showFinancePrice={showFinancePrice} />)
                }
            </div> 
            :  
            <p>
                {t("wheel_default_msg")}
            </p>
            }
        </div>
    )
}


export default WheelsList;

WheelsList.propTypes = {
    HandleSelectedWheel: PropTypes.func,
}

WheelsList.defaultProps = {
    HandleSelectedWheel: () => {},
};